module.exports = __webpack_public_path__ + "img/logo-login.e50d4f05.svg";